import React     from 'react'; 
import Newspaper from '../components/Newspaper.jsx';
import Paper     from '../components/Paper.jsx';
import {Context} from '../services/context.js';
import {Helmet}  from 'react-helmet';

import cx        from 'classnames';
import landscape from './bsb_b010.module.css';
import portrait  from './portrait.module.css';

import pic_BSB100_board from  '../pictures/PCI_express_front.png';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

const text_BSB_G010_1 = [
  {
    header: (
      <p className={cx_header}>
        Powerful Back‑Step Generator
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        This product is currently under development. Prototype availability will be announced here.
      </p>
    )
  },
  {
    header: (
      <p className={cx_header}>
        Functions
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        The BSB‑G010 is a plug‑in board for a Back‑Step Blockchain server, requiring a free PCIe x8 slot. Linux drivers (Node.js) are in development, and sample middleware—similar to that used by Trust.it—will be provided. The board features multiple protection layers to guard against logical and physical attacks. All secrets are self‑generated and remain unknown to the board owner or any third party. An external switch halts the blockchain before any physical access to the server. For optimal throughput, we recommend local disk pools with fault protection. Applications that consume blockchain data can run on the same server if sufficient CPU cores and memory are available; we suggest a separate disk pool for those applications.
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        The middleware interfaces with storage media (disk or SSD arrays) and, in redundant setups, with other Back‑Step Blockchain servers. An independent tool verifies chain integrity. Before operation, each BSB‑G010 undergoes a training phase—similar to AI systems—and while processing the active chain, it can train on the next chain in the background.
      </p>
    )
  },
  {
    header: (
      <p className={cx_header}>
        Management
      </p>
    )
  },
  {
    text: (
      <p className={cx_text}>
        BSB‑G010 provides management functions, statistics, and status reports via a dedicated interface separate from operational functions. Manufactured in Singapore, the product includes a one‑year warranty.
      </p>
    )
  }
];

const text_BSB_G010_2 = [
  {
    header: (
      <p className={cx_header}>
        Preliminary Technical & Operational Data
      </p>
    )
  },
  {
    text: (
      <ul className={cx_ul}>
        <li className={cx_li}>
          <strong>Performance:</strong> Average throughput of 10,000 blocks per second (generator only; excludes application, middleware, and driver overhead).
        </li>
        <li className={cx_li}>
          <strong>Power Consumption:</strong> Approximately 15 W at full load.
        </li>
        <li className={cx_li}>
          <strong>Startup Time:</strong> ~10 seconds from power‑on.
        </li>
        <li className={cx_li}>
          <strong>Pipelining:</strong> Three-stage pipeline—one block in processing, one in the output buffer, and one in the input queue. Middleware must enforce sequential block numbering.
        </li>
        <li className={cx_li}>
          <strong>Hashing:</strong> Separate SHA-3 function for parallel payload hashing.
        </li>
        <li className={cx_li}>
          <strong>Encryption:</strong> Built‑in encryption and key‑management functions.
        </li>
      </ul>
    )
  }
];
  
   

  export class BSB_B010 extends React.Component
  {

    constructor(props)
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  
    

    componentDidMount()
    {
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    }


    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //------------------------------------------------------------------
    //  Prepare the render output
    //------------------------------------------------------------------
    render()
    { 

      if (Context.portrait)
      {
          
          this.component =              
    
            <div className={portrait.backdrop}>
 
              <Helmet>
                <title>BSB G010</title>
                <meta name="description" content="Explains BSB_G010 hardware generator board for Back-Step Blockchain. Shows picture" />
                <meta charset="utf-8" />
              </Helmet>

              <div className={cx_title}>
                Back-Step Generator for servers
              </div>

              <div > 
                < Paper textLines = {text_BSB_G010_1}/> 
              </div>

              <div >
                  <Paper  textLines = {text_BSB_G010_2}/>
              </div>
 
              <div >
                <img src={pic_BSB100_board} alt="picture of BSB_G010 board"/>
                <p>PCIe Gen3 x8 bus.</p> 
                <p>Anti-TamperPCIe touch sensor.</p> 
                <p>Multiple intrusion detecten sensors.</p>
                <p>Backup battery life `{'>'}`10 years.</p> 
              </div>
              
          </div>

      }
      else
      {

        this.component = 
        <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>

          <Helmet>
            <title>BSB B010</title>
            <meta name="description" content="Explains BSB_B010 hardware generator board for Back-Step Blockchain. Shows picture" />
            <meta charset="utf-8" />
          </Helmet>

          {! this.state.content_disabled &&
            <>

              <div className={landscape.title_location}>
                <div className={landscape.title_text}> 
                <p>Back-Step Generator for Servers. </p>
                </div>
              </div>
              
              <div className={landscape.container}>
            
                <div className={landscape.item_left_row_2}> 
                    < Newspaper textLines = {text_BSB_G010_1}/> 
                </div>

                <div className={landscape.item_left_row_3}>
                    <Newspaper  textLines = {text_BSB_G010_2}/>
                </div>

                <div className ={landscape.image_right}>
                  <p style={{textAlign:'center'}}>Similar product for illustration purpose only</p> 
                  <img src={pic_BSB100_board} width='250' alt="picture BSB_B010 server board" />
                </div>
              </div>
            </>
          }
        </div>
      }
      return this.component ;
    }
}  

